import CancelIcon from '@mui/icons-material/Cancel';
import { ListItemText } from '@mui/material';
import { ListItemIcon } from '@mui/material';
import { EMPTY_OPTION } from 'features/brand-voice/components/AutocompleteDropdownMenuContent';
import { FormattedMessage } from 'react-intl';

export function EmptyBrandVoiceMenuItemContent() {
  return (
    <>
      <ListItemIcon>
        <CancelIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id={EMPTY_OPTION.name} />
      </ListItemText>
    </>
  );
}
